import { render, staticRenderFns } from "./StorageSpaceSelect.vue?vue&type=template&id=4c4ee5c8&"
import script from "./StorageSpaceSelect.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports